export default __webpack_public_path__ + "static/media/infoIllustration5.9c20c929.gif";